import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Alunos from "./pages/Alunos";
import Horarios from "./pages/Horarios";
import Turmas from "./pages/Turmas";
import Professores from "./pages/Professores";
import Inscricoes from "./pages/Inscricoes";
import Mensalidades from "./pages/Mensalidades";
import CaixaDiario from "./pages/CaixaDiario";

// Components
import Header from "./components/Header";
import Loader from "./components/Loader";
import PageLoader from "./components/PageLoader";

// 🔒 Private route
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/" />;
};

export default function App() {

  // Loader inicial (refresh)
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1800); // loader inicial maior

    return () => clearTimeout(timer);
  }, []);

  if (initialLoading) return <Loader />;

  return (
    <Router>

      <ToastContainer position="top-right" autoClose={4000} />

      <PageLoader>

        <Routes>

          <Route path="/" element={<Login />} />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Header />
                <Dashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/alunos"
            element={
              <PrivateRoute>
                <Header />
                <Alunos />
              </PrivateRoute>
            }
          />

          <Route
            path="/professores"
            element={
              <PrivateRoute>
                <Header />
                <Professores />
              </PrivateRoute>
            }
          />

          <Route
            path="/turmas"
            element={
              <PrivateRoute>
                <Header />
                <Turmas />
              </PrivateRoute>
            }
          />

          <Route
            path="/horarios"
            element={
              <PrivateRoute>
                <Header />
                <Horarios />
              </PrivateRoute>
            }
          />

          <Route
            path="/inscricoes"
            element={
              <PrivateRoute>
                <Header />
                <Inscricoes />
              </PrivateRoute>
            }
          />

          <Route
            path="/mensalidades"
            element={
              <PrivateRoute>
                <Header />
                <Mensalidades />
              </PrivateRoute>
            }
          />

          <Route
            path="/caixa"
            element={
              <PrivateRoute>
                <Header />
                <CaixaDiario />
              </PrivateRoute>
            }
          />

          <Route path="*" element={<Navigate to="/dashboard" />} />

        </Routes>

      </PageLoader>
    </Router>
  );
}